// extracted by mini-css-extract-plugin
export default {"AuthPage":"AuthPage_AuthPage__8oh9N"};